import { NgModule } from "@angular/core";

import { CommonModule } from "@angular/common";
import { NarikNgxButtonComponent } from "./narik-ngx-button.component";

@NgModule({
  imports: [CommonModule],
  declarations: [NarikNgxButtonComponent],
  exports: [NarikNgxButtonComponent],
  providers: []
})
export class NarikNgxButtonModule {}
